export async function recordMasterDataRefreshHistory(input: {
  kind: "material" | "allocation" | "ownership";
  versionNumber: number | null;
  previousVersionNumber: number | null;
  manualRevisionChanged: boolean;
}): Promise<void> {
  try {
    await fetch("/api/notices/master-data-refresh-history", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        kind: input.kind,
        version_number: input.versionNumber,
        previous_version_number: input.previousVersionNumber,
        manual_revision_changed: input.manualRevisionChanged,
      }),
    });
  } catch {
    // Historisierung darf eine erfolgreich geladene Stammdatenliste nicht zurückrollen.
  }
}

export async function recordAppUpdateHistory(input: { fromVersion: string; toVersion: string }): Promise<boolean> {
  try {
    const response = await fetch("/api/notices/app-update-history", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ from_version: input.fromVersion, to_version: input.toVersion }),
    });
    return response.ok;
  } catch {
    return false;
  }
}
